module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/object/keys.js
 ** module id = ./node_modules/babel-runtime/core-js/object/keys.js
 ** module chunks = 0
 **/